import React from 'react';
import {
  DeleteOutlined,
  EditOutlined,
  CheckCircleOutlined,
  SyncOutlined,
  ClockCircleOutlined,
  CopyTwoTone,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { Table, Space, Popconfirm, Tag } from 'antd';
import { Link } from 'react-router-dom';

const tags = {
  completed: {
    color: 'success',
    icon: <CheckCircleOutlined />,
  },
  pending: {
    color: 'processing',
    icon: <SyncOutlined spin />,
  },
  deleted: {
    color: 'error',
    icon: <CheckCircleOutlined />,
  },
  default: {
    color: 'default',
    icon: <ClockCircleOutlined />,
  },
};

function QrcodeTable({ data, options, onChangeTable, onDeleteQrcode }) {
  const columns = [
    {
      title: 'Base Url',
      dataIndex: 'baseUrl',
      key: 'baseUrl',
      render: (baseUrl, cell) => {
        const url = `${baseUrl}${cell.shortId}`;
        const handelCopy = () => {
          navigator.clipboard.writeText(url);
        };

        return (
          <>
            <CopyTwoTone onClick={handelCopy} style={{ marginRight: '5px', verticalAlign: 'middle' }} />
            <Link to={`/qrcode/edit/${cell.id}`}>{url}</Link>
          </>
        );
      },
    },
    {
      title: 'Created at',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: true,
      sortOrder: options.sorter?.field === 'createdAt' && options.sorter?.order,
      render: (createdAt) => `${dayjs(createdAt).format('DD MMM YYYY HH:mm')}`,
    },
    {
      title: 'Unique id',
      dataIndex: 'shortId',
      key: 'shortId',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      sortOrder: options.sorter?.field === 'status' && options.sorter?.order,
      render: (status) => {
        return (
          <Tag icon={tags[status]['icon']} color={tags[status]['color']}>
            {status}
          </Tag>
        );
      },
    },
    {
      title: 'Total send email',
      dataIndex: 'totalSendEmail',
      key: 'totalSendEmail',
    },
    {
      title: 'Action',
      key: 'action',
      render: ({ id }) => (
        <Space size="middle">
          <Link to={`/qrcode/edit/${id}`}>
            <EditOutlined style={{ fontSize: '1.2em' }} />
          </Link>
          <Popconfirm title="Sure to delete?" onConfirm={() => onDeleteQrcode(id)}>
            <DeleteOutlined style={{ fontSize: '1.2em', color: '#d12c03' }} />
          </Popconfirm>
        </Space>
      ),
    },
  ];
  return (
    <Table
      tableLayout="auto"
      className="clearfix"
      columns={columns}
      dataSource={data}
      style={{ clear: 'both' }}
      rowKey="id"
      pagination={{
        current: options.page,
        pageSize: options.limit,
        total: options.totalResults,
      }}
      onChange={onChangeTable}
    />
  );
}

export default QrcodeTable;
